import env from '../config/env';
import {
CacheDetails,
CacheReloadRequest,
CacheReloadResponse
} from '../interface/cache';
import { AuthorizedService } from './authorized.service';

class CacheService extends AuthorizedService {
  public async getCacheList(): Promise<string[]> {
    const caches = await super.get<string[]>(`api/cache/list`);
    return caches.sort();
  }

  public async getCacheHistory(cache: string): Promise<CacheDetails[]> {
    return await super.get<CacheDetails[]>(`api/cache/${cache}/history`);
  }

  public reloadCache(request: CacheReloadRequest): Promise<CacheReloadResponse> {
    return super.post<CacheReloadResponse, CacheReloadRequest>(`api/cache/reload-cache`, request);
  }
}

const cacheService = new CacheService(env.API_URL);
export default cacheService;
